import { motion } from "framer-motion";
import SiteFooter from "./SiteFooter";
import JournalCarousel from "./JournalCarousel";
import thresholdTexture from "../assets/threshold-texture.webp";

const EASE = [0.22, 1, 0.36, 1];

export default function About({ onBack }) {
  return (
    <motion.section
      className="about-page"
      data-testid="about-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
    >
      <div
        className="about-texture"
        style={{ backgroundImage: `url(${thresholdTexture})` }}
        aria-hidden="true"
      />
      <div className="back-bar">
        <button onClick={onBack} data-testid="about-back-button">
          ← The Hall
        </button>
        <div className="bb-right">
          <button className="mark" data-testid="brand-to-hall-button" onClick={onBack} aria-label="Back to The Hall">
            The WOWOW Gallery
          </button>
        </div>
      </div>

      <motion.div
        className="about-body"
        initial={{ opacity: 0, y: 26 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.25, ease: EASE }}
      >
        <div className="eyebrow">About Us</div>
        <h1 className="display">The Ball Family</h1>
        <p>Founded in 2025 by the Ball Family, operated by Martin and his daughter Elizabeth.</p>
        <p>
          Martin has spent his working life owning and running print operations, with a particular love of
          lenticular. Elizabeth is a luxury market consultant, and she is selective about who she works with. She
          looks for artists with a distinct vision, whose work will carry long-term value for the people who own it,
          and who are committed to the journey. She doesn't work with anyone she hasn't first spent time with. For
          her it's a lifelong relationship, and she remains their advocate throughout. Together they started the
          gallery, which has now exhibited twice at Saatchi Gallery in London, as well as numerous art fairs and
          through private events.
        </p>
        <p>
          Alongside the artist collaborations, we run our own production studio, WOW Studio, where we choose pieces
          from across art history and transform them in our material. We also offer bespoke printing.
        </p>
        <p>
          If you wish to get in touch then email us at{" "}
          <a href="mailto:team@houseofwow.ai" data-testid="about-email-link">
            team@houseofwow.ai
          </a>
          .
        </p>
      </motion.div>

      <JournalCarousel />

      <SiteFooter />
    </motion.section>
  );
}
